import { Component, Inject, OnInit, signal } from '@angular/core';
import { del, get, set } from 'idb-keyval';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { DialogData } from '../confirm-box/confirm-box.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { SetDirectoryComponent } from './set-directory/set-directory.component';
import { EMPTY } from 'rxjs';

@Component({
  selector: 'app-configure-import-directories',
  templateUrl: './configure-import-directories.component.html',
  imports: [
    MatDialogTitle,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    MatDivider,
    SetDirectoryComponent,
    MatDialogActions,
    MatButton,
    MatDialogContent
  ]
})
export class ConfigureImportDirectoriesComponent implements OnInit {
  fileDirectoryHandler = signal<FileSystemDirectoryHandle | null>(null);
  imagesDirectoryHandler = signal<FileSystemDirectoryHandle | null>(null);
  types = [];
  constructor(
    public dialogRef: MatDialogRef<ConfigureImportDirectoriesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.importFolderFromIndexDB();
  }

  setDirectoryHandler(type: string) {
    try {
      (window as any)
        .showDirectoryPicker({ mode: 'read', id: type })
        .then((directoryHandle) => {
          if (type === 'image') {
            this.imagesDirectoryHandler.set(directoryHandle);
          } else {
            this.fileDirectoryHandler.set(directoryHandle);
          }
        })
        .catch(() => EMPTY);
    } catch (error) {
      // To avoid console error
    }
  }

  deleteDirectoryHandler(type: string) {
    !this.types.includes(type) && this.types.push(type);
    if (type === 'image') {
      this.imagesDirectoryHandler.set(null);
    } else {
      this.fileDirectoryHandler.set(null);
    }
  }

  async importFolderFromIndexDB() {
    this.fileDirectoryHandler.set(await get('file'));
    this.imagesDirectoryHandler.set(await get('image'));
  }

  saveHandlers() {
    if (this.fileDirectoryHandler()) {
      del('file');
      set('file', this.fileDirectoryHandler());
    }
    if (this.imagesDirectoryHandler()) {
      del('image');
      set('image', this.imagesDirectoryHandler());
    }
    this.dialogRef.beforeClosed().subscribe((result) => {
      if (!this.fileDirectoryHandler() || !this.imagesDirectoryHandler()) {
        this.types.map((t) => del(t));
      }
    });
    this.dialogRef.close();
  }
}
